import { CourseReducer } from '../Types/CourseReducer';
import { CourseDetailsResponse } from '../Types/CourseDetailsResponse';
import { CourseInstanceResponse } from '../Types/CourseInstanceResponse';
import { CourseProgressResponse } from '../Types/CourseProgressResponse';

export const courseDetailsInitState: CourseDetailsResponse = {
  data: {
    id: '',
    version: '',
    modules: [],
    product: { id: '0', name: '' },
    hasRepositories: true,
  },
  metadata: {},
};

export const courseInstanceInitState: CourseInstanceResponse = {
  data: {
    id: '',
    signature: '',
    selfRegister: false,
    links: {
      schedule: '',
      classroom: '',
      chat: '',
      records: '',
      trello: '',
      jira: '',
      testlink: '',
    },
    courseId: '',
    access: {
      role: '',
      modules: [],
    },
    mentor: { name: '' },
    cs: { name: '' },
    description: '',
    currentMaterial: { id: '', name: '', chapterId: '' },
    product: {
      name: '',
      id: '',
    },
    icon: '',
    roles: [],
  },
  metadata: {},
};

export const courseProgressInitState: CourseProgressResponse = {
  data: {
    id: '',
    modules: [],
    product: {
      name: '',
      id: '',
    },
  },
  metadata: {},
};

export const courseInitState: CourseReducer = {
  courseDetails: courseDetailsInitState,
  courseInstance: courseInstanceInitState,
  courseProgress: courseProgressInitState,
};
